import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom'
import { postStuff } from '../helpers/auth'
import { AlertsContext } from './Layout'
import { Link } from 'react-router-dom';
import { ButtonWIcon } from './Inputs';
import { ButtonWText,  TextInput, inp } from "./Inputs";
import "../css/activate_account.css"


const ActivateAccount = () => {
    const { uid, token} = useParams()
    const addAlertBanner = useContext(AlertsContext);
    const navigate = useNavigate()
    const [showResend, setShowResend] = useState(false)
    const [resendMail, setResendMail] = useState("")
    const [textResponse, setTextResponse] = useState("Zkoušíme váš účet aktivovat")
    
    const body = {
        uid:uid,
        token:token
    }

    useEffect(()=>{

        postStuff("auth/users/activation/", body).then((res)=>{
            setShowResend(false)
            console.log(res)
            if(res.status === 204){
                addAlertBanner("Účet byl aktivován", "success", 5000)
                setTextResponse("Účet aktivován")
                navigate("/reset_pass/t")
            }
            else    {
                setTextResponse("Účet se nepodařilo aktivovat!")
                addAlertBanner("Účet se nepodařilo aktivovat", "danger", 5000)
                setShowResend(true)
            }
        })
    },[])

    function resendActivationMailPress(){
        const body = {
            email: resendMail.trim().toLowerCase()
        }
        postStuff("auth/users/resend_activation/", body).then((res)=>{
            setShowResend(false)
            console.log(res)
            if(res.status === 204){
                addAlertBanner("Úspěch", "success")
                setTextResponse("E-mail byl zaslán na adresu " + resendMail.trim().toLowerCase())
                setShowResend(false)
            }
            else    {
                addAlertBanner("Chyba", "danger")
                setTextResponse("E-mail se nepodařilo poslat. Možná máte již aktivovaný účet nebo váš e-mail neznáme")
            }
            //navigate("/login")
        })

    }

    
    return(<div className="activate-acc">
        <h1>{textResponse}</h1>
        
        {showResend &&

        <p> 
            <h4>Zkontrolujte složku nevyžádané pošty.</h4>
            <div>Pro opětovné zaslání zadejte svůj e-mail</div>
            <TextInput value={resendMail} setValue = {setResendMail} placeholder={"váš e-mail"}/>
            <ButtonWText text={"Poslat"} onClick={resendActivationMailPress}/>
        </p>
        }
    </div>)
}

export default ActivateAccount;